var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71591 9.97752L10.626 1.066C11.3584 0.333633 12.5478 0.333633 13.2803 1.066L14.4346 2.22117C14.5254 2.31258 14.6045 2.41131 14.6748 2.51531C15.1553 3.24305 15.0762 4.2324 14.4346 4.874L5.52245 13.7832C5.48437 13.8213 5.44628 13.833 5.40527 13.8945C5.12402 14.1435 4.79003 14.3017 4.42675 14.4336L0.901458 15.4707C0.654779 15.5439 0.387884 15.4765 0.20595 15.2685C0.024011 15.1133 -0.0440105 14.8467 0.0285871 14.5976L1.06552 11.0732C1.1874 10.6601 1.41093 10.2822 1.71591 9.97752ZM2.41464 11.4687L1.7414 13.7597L4.03124 13.0859C4.19238 13.0303 4.38867 12.9277 4.52929 12.79L11.2207 6.09568L9.37792 4.25291L2.71025 10.9707C2.69296 10.9883 2.67626 11.0058 2.66015 11.0263C2.54706 11.1523 2.46298 11.3047 2.41464 11.4687Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.bbd3cbf81b19df6c39e47ebd832a100d.svg";
export { ForwardRef as ReactComponent };